<script setup lang="ts">
import { Divider } from "~/components/clarity-ui/Divider";
import { Tint } from "~/components/clarity-ui/Tint";
import { useExchangeBox } from "~/composables/shop/useExchangeBoxProduct";
import CommonLabel from "~/templates/components/CommonLabel.vue";

const {
  amountCylinders,
  totalDepositPrice,
  tauschboxPrice,
  nextAmount,
  nextPrice,
  depositLineItemLabel,
} = await useExchangeBox();
</script>

<template>
  <div class="flex flex-col gap-4" data-testid="product-exchange-box-information">
    <div class="flex flex-col gap-2">
      <CommonLabel
        class="font-medium xl:text-2xl"
        path="BWF/shop/productDetailPage/exchangeBox/summaryHeadline"
      />
      <Tint class="text-sm"
        ><CommonLabel path="BWF/shop/productDetailPage/exchangeBox/cylinderAmountHint"
      /></Tint>
    </div>

    <div class="grid grid-cols-4 gap-4">
      <div class="contents text-sm text-black">
        <div class="col-span-3">
          <CommonLabel
            :placeholder="{ amountCylinders }"
            path="BWF/shop/productDetailPage/exchangeBox/summaryCylinders"
          />
        </div>
        <div class="col-span-1 font-medium">
          <SharedPrice :value="tauschboxPrice" />
        </div>
        <div class="col-span-3">
          <CommonLabel
            :placeholder="{ amountCylinders, depositLineItemLabel }"
            path="BWF/shop/productDetailPage/exchangeBox/summaryDeposit"
          />
        </div>
        <div class="col-span-1 font-medium">
          <SharedPrice :value="totalDepositPrice" />
        </div>
        <slot name="depositInfo" />
        <Divider class="col-span-full my-2" />
        <div class="col-span-3 text-base text-black">
          <CommonLabel
            :placeholder="{ nextAmount }"
            path="BWF/shop/productDetailPage/exchangeBox/nextPrice"
          />
        </div>
        <div class="col-span-1 text-base font-medium text-black">
          <SharedPrice :value="nextPrice" />
        </div>
        <slot name="priceInfo" />

        <Divider class="col-span-full mt-4 hidden xl:block" />
      </div>
    </div>
  </div>
</template>
